import { c as _c } from "react/compiler-runtime";
import { IcoArrowTopRight16 } from '@onefootprint/icons';
import type { CreateOnboardingResponse, VaultKind } from '@onefootprint/request-types/dashboard';
import { CodeBlock, LinkButton } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { Trans, useTranslation } from 'react-i18next';
import getBadgeVariantByStatus from '@/utils/get-badge-variant-by-status';
type RunResultProps = {
  run: CreateOnboardingResponse;
  fpId: string;
  entityKind: VaultKind;
};
export const RunResult = t0 => {
  const $ = _c(68);
  const {
    run,
    fpId,
    entityKind
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "testMode.runMode.results"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "entityStatuses"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    t: tStatus
  } = useTranslation("common", t2);
  let t3;
  if ($[2] !== run.requiresManualReview || $[3] !== run.status) {
    t3 = getBadgeVariantByStatus(run.status, run.requiresManualReview);
    $[2] = run.requiresManualReview;
    $[3] = run.status;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const badgeVariant = t3;
  let T0;
  let t10;
  let t11;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] !== badgeVariant || $[6] !== t) {
    const statusTextColor = {
      success: "text-success",
      error: "text-error",
      warning: "text-warning",
      neutral: "text-neutral"
    };
    t11 = "flex flex-col gap-2";
    t9 = "flex flex-col gap-1";
    let t12;
    if ($[16] !== t) {
      t12 = t(_temp);
      $[16] = t;
      $[17] = t12;
    } else {
      t12 = $[17];
    }
    if ($[18] !== t12) {
      t10 = <h3 className="text-label-3 text-primary">{t12}</h3>;
      $[18] = t12;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    t8 = "flex flex-wrap items-center gap-x-2";
    t7 = "text-body-3 text-secondary";
    T0 = Trans;
    t5 = "playbook-builder";
    t6 = _temp2;
    t4 = cx("text-body-3", statusTextColor[badgeVariant]);
    $[5] = badgeVariant;
    $[6] = t;
    $[7] = T0;
    $[8] = t10;
    $[9] = t11;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    T0 = $[7];
    t10 = $[8];
    t11 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  let t12;
  if ($[20] !== run.status) {
    t12 = $_1 => $_1[run.status];
    $[20] = run.status;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== tStatus) {
    t13 = tStatus(t12);
    $[22] = t12;
    $[23] = tStatus;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t13 || $[26] !== t4) {
    t14 = {
      status: <span className={t4}>{t13}</span>
    };
    $[25] = t13;
    $[26] = t4;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== T0 || $[29] !== t14 || $[30] !== t5 || $[31] !== t6) {
    t15 = <T0 ns={t5} i18nKey={t6} components={t14} />;
    $[28] = T0;
    $[29] = t14;
    $[30] = t5;
    $[31] = t6;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t15 || $[34] !== t7) {
    t16 = <p className={t7}>{t15}</p>;
    $[33] = t15;
    $[34] = t7;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  const t17 = `/${entityKind === "business" ? "businesses" : "users"}/${fpId}/onboardings/${run.id}/trace`;
  let t18;
  if ($[36] !== t) {
    t18 = t(_temp3);
    $[36] = t;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t17 || $[39] !== t18) {
    t19 = <LinkButton href={t17} target="_blank" iconComponent={IcoArrowTopRight16} variant="label-3">{t18}</LinkButton>;
    $[38] = t17;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t16 || $[42] !== t19 || $[43] !== t8) {
    t20 = <div className={t8}>{t16}{t19}</div>;
    $[41] = t16;
    $[42] = t19;
    $[43] = t8;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== run.status || $[46] !== t) {
    t21 = run.status === "pending" && <p className="text-body-3 text-tertiary">{t(_temp4)}</p>;
    $[45] = run.status;
    $[46] = t;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== run.continueOnboarding || $[49] !== run.status || $[50] !== t) {
    t22 = run.status === "incomplete" && run.continueOnboarding && <p className="text-body-3 text-tertiary">{t(_temp5)}</p>;
    $[48] = run.continueOnboarding;
    $[49] = run.status;
    $[50] = t;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== run.errorMessage) {
    t23 = run.errorMessage && <p className="text-body-3 text-error">{run.errorMessage}</p>;
    $[52] = run.errorMessage;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== t10 || $[55] !== t20 || $[56] !== t21 || $[57] !== t22 || $[58] !== t23 || $[59] !== t9) {
    t24 = <div className={t9}>{t10}{t20}{t21}{t22}{t23}</div>;
    $[54] = t10;
    $[55] = t20;
    $[56] = t21;
    $[57] = t22;
    $[58] = t23;
    $[59] = t9;
    $[60] = t24;
  } else {
    t24 = $[60];
  }
  let t25;
  if ($[61] !== run.output || $[62] !== t) {
    t25 = run.output && <CodeBlock language="json" title={t(_temp6)} ariaLabel={t(_temp7)} backgroundColor="secondary" maxHeight="180px">{JSON.stringify(run.output, null, 2)}</CodeBlock>;
    $[61] = run.output;
    $[62] = t;
    $[63] = t25;
  } else {
    t25 = $[63];
  }
  let t26;
  if ($[64] !== t11 || $[65] !== t24 || $[66] !== t25) {
    t26 = <div className={t11}>{t24}{t25}</div>;
    $[64] = t11;
    $[65] = t24;
    $[66] = t25;
    $[67] = t26;
  } else {
    t26 = $[67];
  }
  return t26;
};
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.testMode.runMode.results.description;
}
function _temp3($_2) {
  return $_2.viewOnboarding;
}
function _temp4($_3) {
  return $_3.pending;
}
function _temp5($_4) {
  return $_4.continuing;
}
function _temp6($_5) {
  return $_5.output;
}
function _temp7($_6) {
  return $_6.copyOutput;
}